import type { ReactElement } from 'react';
import styles from './ClosedNotice.module.css';

export const CLOSED_NOTICE_TEXT = 'Esta conversa está encerrada. Enviar uma mensagem a reabre.';

/**
 * Acima do campo de mensagem de uma conversa encerrada em que a pessoa PODE responder: o campo continua
 * habilitado, porque enviar uma mensagem reabre a conversa (docs/conversation-status.md); o aviso só
 * evita a surpresa. Quem não pode responder já vê o aviso de permissão no lugar do campo.
 */
export function ClosedNotice(): ReactElement {
  return <p className={styles.notice}>{CLOSED_NOTICE_TEXT}</p>;
}
